export const MINUTES_MIN_INTERVAL = 10
